import type { RouteRecordRaw } from 'vue-router'

export const sequencesRoutes: RouteRecordRaw[] = [
  {
    path: '/sequences',
    name: 'sequences',
    component: () => import('@/views/sequences/SequencesView.vue'),
    meta: { requiresAuth: true, title: 'Sequences' },
  },
  {
    path: '/sequences/new',
    name: 'sequences.create',
    component: () => import('@/views/sequences/SequenceDetailView.vue'),
    meta: { requiresAuth: true, title: 'New Sequence' },
  },
  {
    path: '/sequences/:id',
    name: 'sequences.show',
    component: () => import('@/views/sequences/SequenceDetailView.vue'),
    meta: { requiresAuth: true, title: 'Sequence' },
  },
  {
    path: '/email-templates',
    name: 'email-templates',
    component: () => import('@/views/emailTemplates/EmailTemplatesView.vue'),
    meta: { requiresAuth: true, title: 'Email Templates' },
  },
  {
    path: '/email-templates/new',
    name: 'email-templates.create',
    component: () => import('@/views/emailTemplates/EmailTemplateEditView.vue'),
    meta: { requiresAuth: true, title: 'New Template' },
  },
  {
    path: '/email-templates/:id',
    name: 'email-templates.edit',
    component: () => import('@/views/emailTemplates/EmailTemplateEditView.vue'),
    meta: { requiresAuth: true, title: 'Email Template' },
  },
]
